import { Component, Input, OnInit } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import {
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-form-textarea',
  standalone: true,
  imports: [NzInputModule, ReactiveFormsModule, NgClass],
  templateUrl: './form-textarea.component.html',
  styleUrl: './form-textarea.component.scss',
  host: {
    class: 'grid grid-cols-12 w-full',
  },
})
export class FormTextareaComponent implements OnInit {
  @Input() maxCharacterCount: number | undefined;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) attribute!: string;
  @Input() readOnly: boolean = false;
  @Input() subformGroup: string | null = null;
  @Input() placeholder: string | null = null;
  form!: FormGroup;
  currentForm!: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit() {
    this.form = this.rootFormGroup.control;

    if (this.subformGroup) {
      const group = this.form.get(this.subformGroup) as FormGroup;
      if (!group) {
        throw new Error(
          `SubFormGroup "${this.subformGroup}" does not exist in form`,
        );
      }
      this.currentForm = group;
    } else {
      this.currentForm = this.form;
    }
  }
}
